import { render, staticRenderFns } from "./MobileCard.vue?vue&type=template&id=b6988a48&scoped=true"
import script from "./MobileCard.vue?vue&type=script&lang=js"
export * from "./MobileCard.vue?vue&type=script&lang=js"
import style0 from "./MobileCard.vue?vue&type=style&index=0&id=b6988a48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6988a48",
  null
  
)

export default component.exports